import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { actions } from '../../../../../../../context';

const TextSearchCodes = ({ searchClass }) => {
    const dispatch = useDispatch();
    const codeNameFilter = useSelector(state => state.daylight.codeNameFilter);
    const [inputValue, setInputValue] = useState(codeNameFilter);

    const setCodeNameFilter = (filter) => dispatch(actions.daylight.setCodeNameFilter(filter));

    useEffect(() => {
        const handler = setTimeout(() => {
            setCodeNameFilter(inputValue);
        }, 500); // Set debounce delay here

        return () => clearTimeout(handler);
    }, [inputValue, dispatch]);

    const handleChange = (e) => {
        setInputValue(e.target.value);
    };

    return (
        <th scope="col" className="col col-small">
            <input
                className={searchClass}
                type="search"
                placeholder="Filter Code"
                value={inputValue}
                onChange={handleChange}
            />
        </th>
    );
};

export default TextSearchCodes;
